import { useMutation } from '@tanstack/react-query'
import { answerApi } from '@/services/answers/answers'
import { AnswerSubmissionPayload } from '@/interfaces/answer'

export const useSubmitAnswers = () => {
  return useMutation({
    mutationFn: (payload: AnswerSubmissionPayload) => answerApi.submitAnswers(payload),
  })
}
